import { ReactNode, createContext, useContext } from 'react';

import { useSalesReturnList } from './sales-return-list.hook';

type SalesReturnListContextType = ReturnType<typeof useSalesReturnList>;

export const SalesReturnListContext =
    createContext<SalesReturnListContextType | null>(null);

export const SalesReturnListProvider = ({
    children,
}: {
    children: ReactNode;
}) => {
    const salesReturnList = useSalesReturnList();
    return (
        <SalesReturnListContext.Provider value={salesReturnList}>
            {children}
        </SalesReturnListContext.Provider>
    );
};

export const useSalesReturnListContext = () => {
    const context = useContext(SalesReturnListContext);
    if (!context) {
        throw new Error(
            'useSalesReturnListContext must be used within a SalesReturnListProvider',
        );
    }
    return context;
};
